<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    props: {},
    data() {
        return {};
    },
    methods: {},
    created() { },
};
</script>